<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1">
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="LBLUSEFLAG"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-multi-select
            codeGroupCd="REGULATION_BILL_API_CD"
            itemText="codeName"
            itemValue="code"
            label="관련 법규"
            name="searchLaw"
            @datachange="billCdChange"
            v-model="searchLaw"
          >
          </c-multi-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <c-multi-select
            type="search"
            :comboItems="regulatedItems"
            itemText="regulatedItemName"
            itemValue="regulatedItemCdReplace"
            label="규제 법규"
            name="regulatedItemCd"
            v-model="searchParam.regulatedItemCd"
          >
          </c-multi-select>
        </div>
      </template>
    </c-search-box>

    <c-table
      ref="table"
      title="화학자재 목록"
      :columns="grid.columns"
      :data="grid.data"
      headerEllipsis
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn
            v-if="isAdmin"
            label="규제검증 일괄적용"
            icon="save"
            @btnClicked="saveAll"
          />
          <c-btn
            v-if="editable"
            label="LBLREG"
            icon="add"
            @btnClicked="openPop"
          />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>

    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import transactionConfig from "@/js/transactionConfig";
import selectConfig from "@/js/selectConfig";

export default {
  name: "chem-manage",
  data() {
    return {
      searchLawItems: [],
      searchLaw: [],
      searchParam: {
        plantCd: null,
        useFlag: "Y",
        mdmChemMaterialId: "",
        materialName: "",
        regulatedItemCd: [],
        searchItems: [],
        headerType: "color",
      },
      regulatedItems: [],
      originalData: [],
      filterData: [],
      useFlagItems: [
        { code: "Y", codeName: "사용" },
        { code: "N", codeName: "미사용" },
      ],
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      grid: {
        columns: [
          {
            fix: true,
            id: "original",
            name: "plantName",
            field: "plantName",
            label: "사업장명",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            fix: true,
            id: "original",
            name: "rowNum",
            field: "rowNum",
            label: "No.",
            align: "center",
            style: "width:50px",
            sortable: true,
          },
          {
            fix: true,
            id: "original",
            name: "mdmChemMaterialName",
            field: "mdmChemMaterialName",
            label: "품명",
            align: "left",
            type: "link",
            style: "width:250px",
            sortable: true,
          },
          {
            fix: true,
            id: "original",
            name: "materialCd",
            field: "materialCd",
            label: "자재코드",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            id: "original",
            name: "materialCd1",
            field: "materialCd1",
            label: "자재코드1",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            id: "original",
            name: "materialCd2",
            field: "materialCd2",
            label: "자재코드2",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            id: "original",
            name: "deliveryVendorCd",
            field: "deliveryVendorCd",
            label: "협력사",
            align: "center",
            style: "width:120px",
            sortable: true,
          },
          {
            id: "original",
            name: "mfgVendorName",
            field: "mfgVendorName",
            label: "제조사",
            align: "center",
            style: "width:120px",
            sortable: true,
          },
          {
            id: "original",
            name: "msdsNo",
            field: "msdsNo",
            label: "MSDS No.",
            align: "center",
            style: "width:150px",
            sortable: true,
          },
          {
            id: "original",
            name: "deptNames",
            field: "deptNames",
            label: "사용부서",
            align: "center",
            style: "width:120px",
            sortable: true,
          },
          {
            id: "original",
            name: "usageName",
            field: "usageName",
            label: "용도",
            align: "center",
            style: "width:180px",
            sortable: true,
          },
          {
            id: "original",
            name: "inUnitName",
            field: "inUnitName",
            label: "입고단위",
            align: "center",
            style: "width:70px",
            sortable: true,
          },
          {
            id: "original",
            name: "propertiesStateName",
            field: "propertiesStateName",
            label: "성상",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            id: "original",
            name: "chemFile",
            field: "chemFile",
            label: "제품사진",
            align: "center",
            sortable: true,
            type: "file",
            style: "width: 200px",
          },
          {
            id: "original",
            name: "useFlag",
            field: "useFlag",
            label: "사용여부",
            align: "center",
            style: "width:80px",
            sortable: true,
          },
          {
            id: "original",
            name: "existRegulation",
            field: "existRegulation",
            label: "규제법규포함",
            align: "center",
            type: "color",
            style: "width:70px",
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      headerUrl: "",
      listUrl: "",
      verifiUrl: "",
      regulListUrl: "",
      saveUrl: "",
      gridResult: {
        data: [],
      },
      asis: {
        reguls: [],
        bills: [],
      },
      tobe: {
        reguls: [],
        bills: [],
      },
    };
  },
  computed: {
    isAdmin() {
      return Boolean(this.$store.getters.user.userId === "U000000001");
    },
  },
  beforeMount() {
    this.headerUrl = selectConfig.mdm.mam.chem.header.url;
    this.getHeader();
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.mdm.mam.chem.listreg.url;
      this.regsUrl = selectConfig.mdm.mam.chem.regs.url;

      this.verifiUrl = selectConfig.mdm.mam.chem.materialRegul.verification.url;
      this.regulListUrl = selectConfig.mdm.mam.chem.materialRegul.list.url;
      this.saveUrl = transactionConfig.mdm.mam.chem.materialRegul.save.url;

      this.getList();
    },

    // $http.request를 Promise로 감싸는 래퍼
    requestAsync(url, type, param) {
      return new Promise((resolve, reject) => {
        this.$http.url = url;
        this.$http.type = type;
        this.$http.param = param;
        this.$http.request(
          (res) => resolve(res),
          (err) => reject(err)
        );
      });
    },

    getHeader() {
      this.$http.url = this.headerUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.$_.forEach(_result.data, (_item) => {
          this.grid.columns.push(_item);
        });
        this.originalData = this.$_.cloneDeep(this.grid.columns);
      });
    },

    billCdChange(newValue) {
      this.searchLawItems = [];
      this.searchParam.regulatedItemCd = [];

      if (newValue.length === 0) {
        this.grid.columns = this.$_.cloneDeep(this.originalData);
      } else {
        this.$_.forEach(newValue, (_item) => {
          this.searchLawItems.push(_item.value);
        });
        var _searchLawItems = this.searchLawItems;

        this.filterData = this.originalData.filter(function (object) {
          return (
            _searchLawItems.indexOf(object["id"]) > -1 ||
            object["id"] === "original"
          );
        });
        this.grid.columns = this.filterData;
      }

      this.searchParam.searchItems = [];
      this.$_.forEach(newValue, (_item) => {
        this.searchParam.searchItems.push(_item.value);
      });

      this.$http.url = this.regsUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.regulatedItems = _result.data;
      });
    },

    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },

    linkClick(row) {
      this.openPop(row);
    },

    openPop(row) {
      this.popupOptions.title = "화학자재 상세";
      this.popupOptions.param = {
        mdmChemMaterialId: row ? row.mdmChemMaterialId : "",
        plantCd: row ? row.plantCd : "",
      };
      this.popupOptions.target = () => import(`${"./chemDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },

    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },

    // confirm 후: 전체 검증/저장 완료 뒤에만 callback
    saveAll() {
      window.getApp.$emit("CONFIRM", {
        title: "LBLCONFIRM",
        message: "규제검증을 일괄적용하시겠습니까?",
        type: "info",
        confirmCallback: async () => {
          try {
            await this.getVerifi(); // 여기서 전체 완료까지 기다림
            this.saveCallback(); // 다 끝난 후 실행
          } catch (e) {
            console.error(e);
            window.getApp.$emit("APP_REQUEST_ERROR");
          }
        },
        cancelCallback: () => {},
      });
    },

    // grid.data 전체를 순차로 돌면서
    // verifi 조회 -> regul 조회/val 계산 -> save PUT
    async getVerifi() {
      for (const _item of this.grid.data) {
        // 1) verifi 조회
        const verifiRes = await this.requestAsync(this.verifiUrl, "GET", {
          mdmChemMaterialId: _item.mdmChemMaterialId,
        });
        const gridResultData = verifiRes.data || [];

        // 2) regul 조회 + 저장
        await this.getRegulsAndSave(_item.mdmChemMaterialId, gridResultData);
      }
    },

    async getRegulsAndSave(_mdmChemMaterialId, gridResultData) {
      const regulRes = await this.requestAsync(this.regulListUrl, "GET", {
        mdmChemMaterialId: _mdmChemMaterialId,
      });

      // 기존 as-is / to-be 구조 유지하면서도 로컬로 계산
      this.asis.reguls = regulRes.data || [];
      this.tobe.reguls = this.$_.map(
        this.$_.cloneDeep(this.asis.reguls),
        (item) => {
          return this.$_.assign(item, {
            val:
              this.$_.findIndex(gridResultData, (regulResult) => {
                return (
                  regulResult.regulatedItemCd === item.regulatedItemCd &&
                  regulResult.status === "Y"
                );
              }) > -1
                ? "Y"
                : "N",
          });
        }
      );

      this.asis.bills = [];
      this.tobe.bills = [];

      if (this.asis.reguls && this.asis.reguls.length > 0) {
        this.asis.bills = this.$_.map(this.asis.reguls, (value) => {
          return {
            regulationBillCd: value["regulationBillCd"],
            regulationBillName: value["regulationBillName"],
            reguls: [],
          };
        });

        this.asis.bills = this.$_.uniqBy(this.asis.bills, (item) => {
          return item.regulationBillCd;
        });

        this.tobe.bills = this.$_.sortBy(this.$_.cloneDeep(this.asis.bills), [
          "sortOrder",
          "regulatedItemCd",
        ]);

        this.$_.forEach(this.asis.bills, (bill) => {
          this.$set(
            bill,
            "reguls",
            this.$_.filter(this.asis.reguls, {
              regulationBillCd: bill.regulationBillCd,
            })
          );
        });

        this.$_.forEach(this.tobe.bills, (bill) => {
          this.$set(
            bill,
            "reguls",
            this.$_.filter(this.tobe.reguls, {
              regulationBillCd: bill.regulationBillCd,
            })
          );
        });
      }

      // 3) save PUT
      const saveData = {
        mdmChemMaterialId: _mdmChemMaterialId,
        reguls: this.$_.filter(this.tobe.reguls, { val: "Y" }),
      };

      await this.requestAsync(this.saveUrl, "PUT", saveData);
    },

    saveCallback() {
      window.getApp.$emit("APP_REQUEST_SUCCESS");
      this.getList();
    },
  },
};
</script>
